<template>
  <div class="pagination">
    <button v-if="currentPage > 1" @click="goToPage(currentPage - 1)">Prev</button>
    <div class="pagers">
      <div class="pager" v-for="page in pagination">
        <span v-if="page === currentPage" class="currentPage">{{ page }}</span>
        <span v-else-if="page === '...'">{{ page }}</span>
        <a @click="goToPage(page)" v-else :to="{ name: 'Episodes', query: { page } }">{{ page }}</a>
      </div>
    </div>
    <button v-if="currentPage < totalPages" @click="goToPage(currentPage + 1)">Next</button>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: ['totalPages'],
  methods: {
    goToPage (page) {
      this.$parent.setPage(page, true)
    }
  },
  computed: {
    currentPage () {
      return this.$parent.page
    },
    pagination () {
      let vm = this
      let left = vm.currentPage - 2
      let right = vm.currentPage + 2 + 1
      let range = []
      let rangeWithDots = []
      let l
      for (let i = 1; i <= vm.totalPages; i++) {
        if (i === 1 || i === vm.totalPages || i >= left && i < right) {
          range.push(i)
        }
      }
      for (let i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1)
          } else if (i - l !== 1) {
            rangeWithDots.push('...')
          }
        }
        rangeWithDots.push(i)
        l = i
      }
      return rangeWithDots
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  .pagination
    margin-top: 110px
    margin-bottom: 110px
    font-size: 19px
    justify-content: center
    +until($tablet)
      display: block
    > button
      background: $turquoise
      font-size: 19px
      font-weight: bold
      text-transform: uppercase
      height: 40px
      padding: 0.25em 1em
      letter-spacing: 0.5px
      color: $textColor
      &:first-of-type
        +until($tablet)
          margin-bottom: 15px
        +tablet
          margin-right: 30px
      &:last-of-type
        +until($tablet)
          margin-top: 15px
        +tablet
          margin-left: 30px
    .pagers
      display: flex
      align-items: center
      justify-content: center
      .pager
        > a,
        > span
          display: flex
          width: 40px
          height: 40px
          align-items: center
          justify-content: center
          color: inherit
          font-weight: bold
          letter-spacing: 0.5px
          &.currentPage
            background: $turqoise
            border-radius: 50%

</style>



// WEBPACK FOOTER //
// Pagination.vue?0f1ef960